export class SubscriptionLog {
  constructor(public subscribedFrame: number,
              public unsubscribedFrame: number = Number.POSITIVE_INFINITY) {
  }
}


// WEBPACK FOOTER //
// ../../src/testing/SubscriptionLog.ts